import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { components } from 'react-select';

const FormContainer = styled.div`
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const LoadingText = styled.div`
  color: #666;
  font-size: 0.9rem;
  margin-top: 0.5rem;
`;

const StyledSelect = styled.div`
  .react-select__control {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 0.2rem;
    box-shadow: none;
    
    &:hover {
      border-color: #2D882D;
    }
  }
  
  .react-select__control--is-focused {
    border-color: #2D882D !important;
    box-shadow: 0 0 0 1px #2D882D !important;
  }
  
  .react-select__option--is-selected {
    background-color: #2D882D;
  }
  
  .react-select__option--is-focused {
    background-color: rgba(45, 136, 45, 0.1);
  }
`;

const MultiValue = (props) => {
  const { data, selectProps } = props;
  const [placeholder, setPlaceholder] = React.useState('1');

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    if (value === '') {
      selectProps.onQuantityChange(data.value, 1);
    } else {
      const newQuantity = parseInt(value, 10);
      if (!isNaN(newQuantity)) {
        selectProps.onQuantityChange(data.value, newQuantity);
      }
    }
  };
  
  const handleBlur = () => {
    if (data.quantity === '' || data.quantity == null || isNaN(data.quantity)) {
      selectProps.onQuantityChange(data.value, 1);
    }
    setPlaceholder('1');
  };

  const handleFocus = () => {
    setPlaceholder('');
  };

  return (
    <components.MultiValue {...props}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        width: '100%',
        gap: '6px',
        minHeight: '24px'
      }}>
        <div style={{ 
          flex: '1',
          hyphens: 'auto',
          lineHeight: '1.2',
          minWidth: 0,
          whiteSpace: 'break-spaces',
        }}>
          {data.label}
        </div>
        <input
          type="number"
          min="1"
          value={data.quantity || ''}
          placeholder={placeholder}
          onChange={handleQuantityChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onClick={e => e.stopPropagation()}
          onKeyDown={e => {
            if (['Backspace', 'Delete'].includes(e.key)) {
              e.stopPropagation();
            }
          }}
          style={{
            width: 35,
            height: 24,
            border: '1px solid #ccc',
            borderRadius: 8,
            padding: '0 4px',
            fontSize: 13,
            background: '#f8f9fa',
            outline: 'none',
            textAlign: 'center',
            MozAppearance: 'textfield',
            WebkitAppearance: 'none',
            appearance: 'textfield',
            flexShrink: 0,
            minWidth: 35,
            zIndex: 1
          }}
        />
      </div>
    </components.MultiValue>
  );
};

const EventAssignEquipment = ({
  equipmentList,
  selectedEquipment,
  onChange,
  onQuantityChange
}) => {
  const [equipment, setEquipment] = useState([]);
  const [fetchingEquipment, setFetchingEquipment] = useState(true);

  useEffect(() => {
      setEquipment(equipmentList);
      setFetchingEquipment(false);
  }, [equipmentList]);
  
  // For react-select
  const equipmentOptions = useMemo(() => {
    return equipment.map(e => ({ value: e.id, label: e.name, _l: e.name.toLowerCase() }));
  }, [equipment]);

  return (
    <FormContainer>
      <Label>Add Equipment</Label>
      
      {fetchingEquipment ? (
        <LoadingText>Loading equipment...</LoadingText>
      ) : (
        <div>
          <StyledSelect>
          <Select
            className="react-select"
            classNamePrefix="react-select"
            options={equipmentOptions}
            value={selectedEquipment}
            onChange={onChange}
            onQuantityChange={onQuantityChange}
            placeholder="Select equipment..."
            isMulti
            isClearable
            autoFocus={false}
            menuPortalTarget={document.body}
            filterOption={(option, rawInput) =>
              option.data._l.includes((rawInput || '').toLowerCase())
            }
            components={{ MultiValue }}
          />
          </StyledSelect>
        </div>
      )}
    </FormContainer>
  );
};

export default EventAssignEquipment;